// ECMJ 프로그램 아이디 : REQ_대한항공 적립몰_01_01 (jg26.kim)
import React, { useCallback, useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';

import clsx from 'clsx';

import useSticky from '@ecp/common/src/hooks/useSticky';
import { Spacing } from '@ecp/common/src/layouts/Spacing';
import { HorizontalDivider } from '@ecp/common/src/layouts/flex/styled';

import mainFunctionApi from '@fo-apis/display/mainFunctionApi';
import SideFloatingArea from '@fo-pages/home/gnb/sideFloating/SideFloatingArea';
import KoreanAirSavingsGnbHeader from '@ecp/fo/sites/koreanairSavings/components/gnb/KoreanAirSavingsGnbHeader';
import { Container, GnbWrapper, GnbHeaderContainer } from '@ecp/fo/sites/koreanairSavings/styles/gnb/KoreanAirSavingsGnbStyles';

export default function KoreanAirSavingsGnb() {
  const { ref, sticky } = useSticky();
  const className = clsx({ sticky });

  const [searchPhraseList, setSearchPhraseList] = useState([]);
  const [searchPraseListIndex, setSearchPraseListIndex] = useState(0);

  const { pathname } = useLocation();

  const fetchSearchPhraseList = useCallback(async () => {
    const { result } = await mainFunctionApi.getSearchPhraseList();
    const searchPhraseList = result.map(({ text, pcNewTab, pcUrl }) => ({
      text,
      pcUrl,
      target: pcNewTab ? '_blank' : '_self',
    }));
    setSearchPhraseList(searchPhraseList);
  }, []);

  useEffect(() => {
    (async () => {
      try {
        await Promise.all([fetchSearchPhraseList()]);
      } catch (e) {
        console.error(e);
      }
    })();
  }, [fetchSearchPhraseList]);

  useEffect(() => {
    setSearchPraseListIndex(searchPraseListIndex >= searchPhraseList.length - 1 ? 0 : searchPraseListIndex + 1);
  }, [pathname]);

  return (
    <Container className={className}>
      <GnbWrapper className={className}>
        <GnbHeaderContainer className={className}>
          {!sticky && <Spacing top={23} />}
          <KoreanAirSavingsGnbHeader
            ref={ref}
            searchPhraseList={searchPhraseList}
            searchPraseListIndex={searchPraseListIndex}
          />
          <Spacing top={!sticky ? 19 : 14} />
          <HorizontalDivider width="calc(max(100vw, 1630px))" />
          {/*{!sticky && <Spacing top={26} />}*/}
          {/*<Spacing top={46} />*/}
          <SideFloatingArea />
        </GnbHeaderContainer>
      </GnbWrapper>
    </Container>
  );
}
